<template>
  <header>
    <a class="logo-link" href="/" @click.prevent="navigate('index', null)">
      <img src="~assets/logo-slaktis.svg?file" alt="Ateljéns Pizza Slaktis" class="main-logo" />
    </a>

    <div class="welcome-content">
      <h1>Välkommen till <br />Ateljéns Pizza Slaktis</h1>
    </div>

    <nav v-if="document && document.links">
      <ul>
        <li class="nav-item-container" v-for="(link, index) in document.links" :key="index">
          <a :class="['nav-item', link.type]" :href="urlFor(link)" @click.prevent="navItemClick(link)">
            {{ link.title }}
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import SliceLoader from 'mixins/slice-loader';
import Navigation from 'mixins/navigation';

export default {
  name: 'HeaderSlaktis',
  mixins: [SliceLoader, Navigation],
  data() {
    return {
      contentParams: { type: 'navigation', uid: '*', location: 'slaktis' }
    };
  },

  methods: {
    navItemClick(link) {
      this.actionFor(link);
    },

    navigate(route, uid) {
      const { currentRoute } = this.$router;
      const location = this.$route.params.location || this.$route?.meta?.location;

      let targetRouteName = route;
      if (uid === 'takeaway') {
        targetRouteName = 'takeaway';
      }

      const isSameRoute = currentRoute.name === targetRouteName;
      const isSameLocation = currentRoute.params.location === location;
      const isUidMatch = currentRoute.params.uid === uid;
      const isIndexRoute = route === 'index';

      if (isSameRoute && isSameLocation && (isUidMatch || isIndexRoute || uid === 'takeaway')) {
        return;
      }

      const params = isIndexRoute ? {} : { uid, location };
      const routerParams = { name: targetRouteName, params };

      this.$router.push(routerParams);
    }
  }
};
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/helpers'
  @require '~global/breakpoints'
  @require '~global/typo'

  header
    display: flex
    flex-direction: column
    align-items: center
    width: 100%
    padding: 4rem $default-padding-mobile 0 $default-padding-mobile

  .logo-link
    width: 100%
    line-height: 0
    margin-bottom: 3rem
    text-align: center

    img
      width: 100%
      max-width: 900px

  .welcome-content
    display: flex
    flex-direction: column
    gap: 0.25rem
    text-align: center
    margin-bottom: .9rem

  h1
    margin-bottom: 2rem
    text-transform: uppercase
    line-height: 1.3rem

  nav
    width: 100%
    max-width: 600px
    text-align: center

  .nav-item-container
    margin-bottom: 1.4rem

  .nav-item
    @extend .t-subHeader
    border-bottom: 1px solid

  @media (max-width: $mobile)
    .nav-item
      font-size: .9rem
      margin: 0 .3rem
</style>
